import './FindPerfectFreelancerSection.scss';
import freelancerImage from '../../../../assets/images/landing/freelancer_in_cafe.png';
import { useNavigate } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const FindPerfectFreelancerSection = () => {
  const navigate = useNavigate();

  const handleStartProject = () => {
    navigate('/categories');
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <section className='find-freelancer-section'>
      <div className='freelancer-container'>
        {/* Left Content */}
        <div className='freelancer-content'>
          <h1 className='freelancer-title'>
            Find Your Perfect Freelancer Today
          </h1>
          <p className='freelancer-description'>
            Join thousands of entrepreneurs who have already discovered the power of AI-driven freelancer matching. Get your project started in minutes, not days.
          </p>
          <div className='freelancer-buttons'>
            <button className='primary-button' onClick={handleStartProject}>
              Start your first project
            </button>
            <button className='secondary-button' onClick={scrollToTop}>
              <AutoAwesomeIcon/>
              Ask GenieAI
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className='freelancer-image'>
          <div className='image-placeholder'>
            <img className='freelancer-img' src={freelancerImage} alt="freelancer" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FindPerfectFreelancerSection;
